<script>
  export let control = null
  export let invalidities = []
</script>
{#if control && control.require_type && invalidities.length}
  {#each invalidities as invalidity}
    {#if control.id === invalidity.controlId}
      <div class="text-red">
        {invalidity.text}
      </div>
    {/if}
  {/each}
{/if}
